import { AnnouncementsState } from './types';

export const initialState: AnnouncementsState = {
  loadingAnnouncements: false,
  scheduledAnnouncements: {},
  savingAnnouncement: false,
};
